import { useIntl } from '@/intl'
import { CarOption } from '@/scopes/checkout/components/services/CarRentalFilteringService/CarOption'
import { Carousel, Slide } from '@/scopes/checkout/components/services/CarRentalFilteringService/Carousel/Carousel'
import { RentalCarListerView } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/RentalCarListerView'
import {
  carToBeSelected,
  useCarRentalServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { useService } from '@/scopes/checkout/domain/hooks'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { space, SpaceBetween, tk, tok, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'
import { ServiceType } from '../../../domain/types'

const CarRentalWrapper = styled.div`
  margin-left: -${space('primitives_space_16')};
  margin-right: -${space('primitives_space_16')};

  @media ${tk('mq_tablet')} {
    margin-left: calc(-1 * (${space('primitives_space_16')} + ${space('primitives_space_4')}));
    margin-right: calc(-1 * (${space('primitives_space_16')} + ${space('primitives_space_4')}));
  }
  @media ${tk('mq_desktop_sm')} {
    margin-left: ${space('primitives_space_0')};
    margin-right: ${space('primitives_space_0')};
  }
`
const ExtraHintText = styled(Typography)`
    ${Typography.modVariant('body-md')}
    color: ${tok('semantics_content_color')};
    text-align: center;
`

export function CarsListView() {
  const { service } = useService(ServiceType.CarRentalFiltering)
  const { isDesktopSm } = useBreakpoints()
  const intl = useIntl()
  const selectingCar = useCarRentalServiceStore(carToBeSelected)

  if (!service)
    return null

  const { options } = service

  return (
    <SpaceBetween direction="y" spacing={space('primitives_space_16')}>
      {!isDesktopSm && (
        <CarRentalWrapper>
          <Carousel>
            {Object.values(options ?? {})
              .slice(0, 3)
              .map(option => (
                <Slide key={option.value}>
                  <CarOption key={option.value} isSelected={String(option.value) === String(selectingCar)} {...option} />
                </Slide>
              ))}
          </Carousel>
        </CarRentalWrapper>

      )}
      {isDesktopSm && (
        Object.values(options ?? {})
          .slice(0, 3)
          .map((option) => {
            return (
              <CarOption
                key={option.value}
                isSelected={String(option.value) === String(selectingCar)}
                {...option}
              />
            )
          })
      )}

      <ExtraHintText>
        {intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_extra_car_options' })}
      </ExtraHintText>
      <RentalCarListerView />
    </SpaceBetween>
  )
}
